import { useState, useEffect } from "react";
import { ERROR_COLOR, THEME_COLOR } from "../vars";
import { useQuery } from "@tanstack/react-query";
import { fetchBadgeCounts } from "../api/users";

export default function useFavicon() {
  const [linkEl] = useState(() => {
    let el = document.querySelector('link[rel="icon"]')! as HTMLLinkElement;

    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "icon");
      el.setAttribute("type", "image/png");
      document.head.appendChild(el);
    }

    return el;
  });

  const { unreadCount } = useQuery({
    queryKey: ["users", "me", "badgeCounts"],
    queryFn: fetchBadgeCounts,
    select: (queryData) => queryData.data,
  }).data!;

  useEffect(() => {
    const canvas = document.createElement("canvas");
    const cxt = canvas.getContext("2d")!;

    canvas.width = 32;
    canvas.height = 32;
    if (unreadCount > 0) {
      cxt.beginPath();
      cxt.arc(
        canvas.width / 2,
        canvas.height / 2,
        canvas.width * 0.47,
        0,
        2 * Math.PI,
        false
      );
      cxt.fillStyle = ERROR_COLOR;
      cxt.fill();

      if (unreadCount < 10) {
        cxt.textAlign = "center";
        cxt.textBaseline = "middle";
        cxt.font =
          '24px bold -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",sans-serif';
        cxt.fillStyle = "#fff";

        cxt.fillText(
          unreadCount.toString(),
          canvas.width / 2,
          canvas.height / 2 + 1
        );
      }
    } else {
      const path = new Path2D(
        "M15.857 10.714a3.857 3.857 0 11-7.714 0 3.857 3.857 0 017.714 0M11.782 16.595c-3.271-.12-5.826-2.863-5.705-6.126.12-3.262 2.87-5.81 6.141-5.69 3.272.12 5.826 2.863 5.705 6.126-.12 3.263-2.87 5.81-6.141 5.69zm-1.83 7.133c.576.571 1.559.186 1.59-.625l.03-.845a.927.927 0 01.887-.893c5.531-.232 10.04-4.672 10.248-10.284C22.93 5.045 18.09-.006 11.978 0 6.483.006 1.822 4.255 1.33 9.714a10.641 10.641 0 002.787 8.21l.002.002 5.833 5.802z"
      );
      cxt.fillStyle = THEME_COLOR;
      cxt.translate(4, 2);
      cxt.scale(1.15, 1.15);
      cxt.fill(path);
    }

    const dataUri = canvas.toDataURL();
    linkEl.href = dataUri;
  }, [unreadCount]);
}
